export const dataHero = {
  eyebrow: "Gatsby Careers",
  title: "The Gatsby Salary Calculator",
  lede: "Help calculate your salary at Gatsby",
}
